<script setup lang="ts">
import unexpectedEventsAndLongTimeContinuousDrivingExtensions from "src/types/responses/unexpectedEventsAndLongTimeContinuousDrivingExtensions";
import UnexpectedEventRegisterModal from "@/components/DailyReportUpdateModalParts/UnexpectedEventRegisterModal.vue";
import UnexpectedEventConfirmModal from "@/components/DailyReportUpdateModalParts/UnexpectedEventConfirmModal.vue";
import getUnexpectedEventType from "@/types/responses/getUnexpectedEvent";
import Api from "@/services/api/ApiServiceFabrick";
import DeliveryPlan from "@/types/DeliveryPlan";
import { Ref, ref, computed } from "vue";
import i18n from '@/lang/i18n';

const emits = defineEmits(['update:modelValue', 'cancel'])

const props = withDefaults(
  defineProps<{
    modelValue: boolean
    deliveryPlan: DeliveryPlan
    unexpectedEvent: getUnexpectedEventType
    selectedUnexpectedEvent?: unexpectedEventsAndLongTimeContinuousDrivingExtensions
    getUnexpectedEventAndLongTimeDrivingExtensions?: () => void
    createAuthority: boolean
    updateAuthority: boolean
    showFlash: (message: string, show: boolean, type: string, fadeout: boolean) => void
  }>(),
  {
    deliveryPlan: {},
    createAuthority: true,
    updateAuthority: true,
  }
)

const localUnexpectedEvent = ref({} as getUnexpectedEventType)
const isUnexpectedEventLoading: Ref<boolean> = ref(false)
const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

const registerModalStatus: Ref<boolean> = ref(false)

const registerModalTitle = computed(() => {
  return `${i18n.global.t('pages.dailyReports.unexpectedEventRegisterModal.titlePrefix')}${registerModalTitleSuffix.value}`
})

const registerModalTitleSuffix = computed(() => {
  return props.selectedUnexpectedEvent ? i18n.global.t('pages.dailyReports.unexpectedEventRegisterModal.editTitle') : i18n.global.t('pages.dailyReports.unexpectedEventRegisterModal.registerTitle')
})

function confirm() {
  modelValue.value = false
  registerModalStatus.value = true
  if (props.selectedUnexpectedEvent) getUnexpectedEvent(props.selectedUnexpectedEvent)
}

function getUnexpectedEvent(item: unexpectedEventsAndLongTimeContinuousDrivingExtensions) {
  isUnexpectedEventLoading.value = true
  Api().getUnexpectedEvent(item.id).then((data: getUnexpectedEventType) => {
    localUnexpectedEvent.value = data
    isUnexpectedEventLoading.value = false
  })
}
</script>
<template>
  <UnexpectedEventConfirmModal
    v-model="modelValue"
    :confirm="confirm"
  />
  <UnexpectedEventRegisterModal
    v-if="registerModalStatus"
    v-model="registerModalStatus"
    :title="registerModalTitle"
    :deliveryPlan="props.deliveryPlan"
    :unexpectedEvent="localUnexpectedEvent"
    :isUnexpectedEventLoading="isUnexpectedEventLoading"
    :getUnexpectedEventAndLongTimeDrivingExtensions="props.getUnexpectedEventAndLongTimeDrivingExtensions"
    :createAuthority="props.createAuthority"
    :updateAuthority="props.updateAuthority"
    :showFlash="props.showFlash"
  />
</template>
